import styled from 'styled-components'
import { WHITE } from '../../styles/colors'

interface ProgressBarProps {
  $progress: number;
}

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Container = (styled.div`
  position: relative;
  width: 100%;
  height: 6px;
  border-radius: 20px;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.5);
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ProgressBar = (styled.div<ProgressBarProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props: ProgressBarProps) => `${props.$progress * 100}%`};
  height: 100%;
  background-color: ${WHITE};
  border-radius: 100px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
